import { api } from "../../../../services/api";

export async function openAllStore({ companiesId }) {
  await api.post("/updateAllLojaAberta", {
    companiesCdEmpresa: companiesId.join(","),
  });
}
